import { SchoolClass } from './school-class.model';

export interface StudentSessionSummary {
  studentID: number,
  firstName: string,
  lastName: string,
  grade: number,
  englishLanguageLearner: boolean,
  extraSupportNeeded: false,
  startDate: string,
  endDate: string,
  schoolClass: SchoolClass,
}

export interface SessionStudent {
  key: string,
  firstName: string,
  lastName: string,
}

// This 'all' student is used in report filter dropdowns, the same way ManagementUser.getGenericUser() is. It is a shared
// constant rather than a factory so that ngModel selection matching against the option list holds onto object identity.
export const ALL_STUDENTS: SessionStudent = { key: 'all', firstName: 'All', lastName: 'Students' } ;

// Identifies the student a session belongs to. This endpoint does not reliably populate studentID, which is why the grouping
// in the session summary report has always keyed on name, so fall back to the name when there is no usable ID.
export function sessionStudentKey(session: StudentSessionSummary): string {
  return (session.studentID) ? `${session.studentID}` : `${session.firstName} ${session.lastName}` ;
}
